import { useServerEnrolledStatsigExperiment } from '../../../../../attendee/discover/src/context/experiments';

interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}
enum ExperimentValues {
    control = 'control',
    searchHierarchy = 'search_hierarchy',
}

export const SearchBarExperiment: Experiment<typeof ExperimentValues> = {
    name: 'search_page_hierarchy',
    paramName: 'search_page',
    values: ExperimentValues,
};
//TODO: Search Page Hierarchy experiment cleanup EB-228109
export const useGetSearchBarVariant = () => {
    const updatedHierarchyVariant = useServerEnrolledStatsigExperiment<string>({
        name: SearchBarExperiment.name,
        paramName: SearchBarExperiment.paramName,
        defaultValue: SearchBarExperiment.values.control,
    }).variant;

    return updatedHierarchyVariant !== 'control';
};
